import React, { FC } from 'react';
import styled from 'styled-components';
import { SkeletonBlock, SkeletonPageHeader, SkeletonPageShell, SkeletonRow, SkeletonStack } from 'src/components/widgets/skeleton';

const FontsSkeletonShell = styled(SkeletonPageShell)``;

const FontsSkeletonHeader = styled(SkeletonPageHeader)``;

const FontsTabsSkeleton = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 18px;
    min-width: 0;
`;

const FontsFiltersSkeleton = styled.div`
    display: grid;
    grid-template-columns: minmax(220px, 1fr) 220px;
    gap: 12px;
    align-items: end;
    margin-bottom: 18px;
    min-width: 0;

    @media (max-width: 700px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

const FontsTableSkeleton = styled.div`
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 8px;
    background: #ffffff;
    overflow: hidden;
    min-width: 0;
`;

const FontsTableRowSkeleton = styled.div`
    display: grid;
    grid-template-columns: minmax(180px, 1fr) 150px 120px 84px;
    gap: 18px;
    align-items: center;
    min-height: 58px;
    padding: 14px 18px;
    border-bottom: 1px solid ${(props) => props.theme.skeleton.backgroundColor};
    min-width: 0;

    &:last-child {
        border-bottom: 0;
    }

    @media (max-width: 760px) {
        grid-template-columns: minmax(0, 1fr) 84px;
    }
`;

const FontsOptionalColumn = styled.div`
    @media (max-width: 760px) {
        display: none;
    }
`;

export const FontsPageSkeleton: FC = () => (
    <FontsSkeletonShell aria-hidden='true'>
        <FontsSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(180px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(420px, 100%)' $height='13px' />
            </SkeletonStack>
            <SkeletonRow $gap='8px'>
                <SkeletonBlock $width='132px' $height='36px' $radius='6px' />
                <SkeletonBlock $width='86px' $height='36px' $radius='6px' />
            </SkeletonRow>
        </FontsSkeletonHeader>
        <FontsTabsSkeleton>
            <SkeletonBlock $width='86px' $height='34px' $radius='17px' />
            <SkeletonBlock $width='86px' $height='34px' $radius='17px' />
            <SkeletonBlock $width='190px' $height='34px' $radius='17px' />
        </FontsTabsSkeleton>
        <FontsFiltersSkeleton>
            <SkeletonBlock $height='38px' $radius='6px' />
            <SkeletonBlock $height='38px' $radius='6px' />
        </FontsFiltersSkeleton>
        <FontsTableSkeleton>
            {Array.from({ length: 8 }).map((_, index) => (
                <FontsTableRowSkeleton key={index}>
                    <SkeletonBlock $width={index % 2 === 0 ? '240px' : '170px'} $height='15px' />
                    <FontsOptionalColumn>
                        <SkeletonBlock $width='92px' $height='22px' $radius='11px' />
                    </FontsOptionalColumn>
                    <FontsOptionalColumn>
                        <SkeletonBlock $width='80px' $height='13px' />
                    </FontsOptionalColumn>
                    <SkeletonRow $gap='8px' $justify='flex-end'>
                        <SkeletonBlock $width='28px' $height='28px' $radius='4px' />
                        <SkeletonBlock $width='28px' $height='28px' $radius='4px' />
                    </SkeletonRow>
                </FontsTableRowSkeleton>
            ))}
        </FontsTableSkeleton>
    </FontsSkeletonShell>
);
